import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useAtom } from "jotai/index";
import { z } from "zod";

import { isOwner } from "@/lib/auth-predicates";
import StatanalyticsPage from "@/pages/statanalytics-page";
import { meStore } from "@/store/store";

const STATSERVICE_VISUALIZATION_TABS = {
  svetofor: 0,
  trading: 1,
  heatmap: 2,
  timingAnalize: 3,
  handExports: 4,
} as const;

const searchParamsSchema = z.object({
  statserviceVisualizationTab: z.nativeEnum(STATSERVICE_VISUALIZATION_TABS).default(0),
});

export const Route = createFileRoute("/statanalytics/")({
  component: Component,
  validateSearch: (search) => searchParamsSchema.parse(search),
});

function Component() {
  const [me] = useAtom(meStore);

  if (me?.stat_visualization.length === 0 && !isOwner(me)) {
    return <Navigate to="/" />;
  }

  return <StatanalyticsPage />;
}
